import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
// import {setTeams} from '../team/teamSlice' - No longer needed

export interface TeamInfo {
  id: string
  name: string
  componentId?: string
  owner?: string
}

export interface ProgramDashboard {
  id: string
  name: string
  configurationItemBusAppName?: string
  ownerDept?: string | 'missing' // Can be missing string literal
  componentDashboards: TeamInfo[]
  cloudServiceName?: string
  appOwnerEmail?: string
  visibleOnSeMetricsPage?: boolean // Flag to determine if program should appear in SE Metrics
  owners?: string[] // Array of owner email addresses for program ownership checks
  incidentsCount?: number // Number of incidents for filtering
  // New KPI fields from seMetricsKPIValues
  totalDeployments?: number
  totalBugs?: number
  incidentCounts?: string | number
  criticalVulnerabilities?: string | number
  highVulnerabilities?: string | number
  infrastructureCost?: string
}

interface ProgramState {
  programs: ProgramDashboard[]
  allProgramsList: any[] // Complete list of programs for dropdown (unprocessed)
  detailedProductDashboards: ProgramDashboard[] // Detailed product dashboards without pagination
  qaMetrics: {
    selectedVersion: string | null
    selectedEnvironment: string | null
    testAutomationPanelOpen: boolean
    manualTestCasesPanelOpen?: boolean
  }
}

const initialState: ProgramState = {
  programs: [],
  allProgramsList: [],
  detailedProductDashboards: [],
  qaMetrics: {
    selectedVersion: null,
    selectedEnvironment: null,
    testAutomationPanelOpen: false,
  },
}

const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    setPrograms: (state, action: PayloadAction<ProgramDashboard[]>) => {
      state.programs = action.payload
    },
    setAllProgramsList: (state, action: PayloadAction<any[]>) => {
      state.allProgramsList = action.payload
    },
    setDetailedProductDashboards: (state, action: PayloadAction<ProgramDashboard[]>) => {
      state.detailedProductDashboards = action.payload
    },
    // addTeamProgramRelationship action removed - no longer needed

    clearPrograms: (state: ProgramState) => {
      state.programs = []
    },
    clearAllProgramsList: (state: ProgramState) => {
      state.allProgramsList = []
    },
    clearDetailedProductDashboards: (state: ProgramState) => {
      state.detailedProductDashboards = []
    },
    setQAMetricsData: (state: ProgramState, action: PayloadAction<{version: string; environment: string}>) => {
      state.qaMetrics.selectedVersion = action.payload.version
      state.qaMetrics.selectedEnvironment = action.payload.environment
    },
    clearQAMetricsData: (state: ProgramState) => {
      state.qaMetrics.selectedVersion = null
      state.qaMetrics.selectedEnvironment = null
    },
  },
})

export const {
  setPrograms,
  setAllProgramsList,
  setDetailedProductDashboards,
  clearPrograms,
  clearAllProgramsList,
  clearDetailedProductDashboards,
  setQAMetricsData,
  clearQAMetricsData,
} = programSlice.actions

export default programSlice.reducer
